import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Troubleshoot from "./troubleshoot";
import { documentUploadUrl } from "services/redux/fileUpload/action";
import {
    getFormDropdowns,
    getTsQuestionnaire,
    postTsQuestionnaire,
  } from "services/redux/fileComplain/action"

const mapStateToProps = (state) => ({
    formDropdowns: state.fileComplainReducer.formDropdowns,
    questionnaireList: state.fileComplainReducer.questionnaireList,
    questionnaireSaveRes: state.fileComplainReducer.questionnaireSaveRes,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    getFormDropdowns,
    getTsQuestionnaire,
    postTsQuestionnaire,
    documentUploadUrl,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Troubleshoot);
